<template>
    <div class="customer-nutzergruppen">
        <v-card>
            <v-card-title class="pt-2 pb-2">
                <TippTitle position="bottom" :tipp="about" title="Nutzergruppen" :loading="usergroups.loading" :reloadCb="getUsergroups" />
            </v-card-title>
            <v-card-text class="pt-0">
                <KeineDaten v-if="usergroupKeys.length <= 0"></KeineDaten>
                <v-tabs v-model="activeTab" v-if="usergroupKeys.length > 0">
                    <v-tab v-for="(ug, index) in usergroupKeys" :key="`customer-nutzergruppen__tab-${usergroupKeys[index]}`">
                        {{ ug }}
                    </v-tab>
                    <v-tab-item v-for="(ug, index) in usergroupsAsArray" :key="`customer-nutzergruppen__tab-item-${usergroupKeys[index]}`">
                        <NutzergruppenProStore :usergroups="ug" />
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import NutzergruppenProStore from '@/components/customer/NutzergruppenProStore.vue';
import KeineDaten from '@/components/customer/KeineDaten.vue';
import TippTitle from '@/components/TippTitle.vue';

export default {
    name: 'Nutzergruppen',
    components: {
        NutzergruppenProStore,
        KeineDaten,
        TippTitle,
    },
    data() {
        return {
            about: 'Zeigt die Nutzergruppen mit Identifikationsnummer und Beschreibung je CeleraOne-Store an denen der Nutzer zugehörig ist.',
            activeTab: null,
        };
    },
    computed: {
        ...mapGetters('customerDetail', ['usergroupKeys', 'usergroupsAsArray']),
        ...mapState('customerDetail', ['usergroups']),
    },
    methods: mapActions('customerDetail', ['getUsergroups']),
};
</script>

<style scoped lang="scss"></style>
